import Button from '@componentLibrary/buttons/Button';

import {
    CheckBox as CheckBoxChecked,
    CheckBoxOutlineBlank as CheckBoxUnchecked,
} from '@components/icons';

import { appendClasses } from '@helpers/ui';

import InputLabel from '../InputLabel';

import './DayOfWeekPicker.scss';

const weekDayOptions = [
    {
        value: 0,
        label: 'Sun',
    },
    {
        value: 1,
        label: 'Mon',
    },
    {
        value: 2,
        label: 'Tue',
    },
    {
        value: 3,
        label: 'Wed',
    },
    {
        value: 4,
        label: 'Thu',
    },
    {
        value: 5,
        label: 'Fri',
    },
    {
        value: 6,
        label: 'Sat',
    },
];

interface DayOfWeekPickerProps {
    label?: string;
    value: number[];
    variant?: 'flat' | 'filled';
    onChange: (value: number[]) => void;
    disabled?: boolean;
    overrideOptions?: { value: number; label: string }[];
}

// with the addition of 'overrideOptions', this is more or less a generic value picker now
// still keeping the name 'DayOfWeekPicker' for easy discoverability
const DayOfWeekPicker = ({
    label,
    value,
    variant,
    onChange,
    disabled,
    overrideOptions,
}: DayOfWeekPickerProps) => {
    const classNamesAppended = appendClasses([
        'day-of-week-picker',
        `day-of-week-picker-variant-${variant}`,
    ]);

    const selectedBtnVariant = variant ?? 'smooth';

    const onToggleDayOfWeek = (day: { value: number; label: string }) => {
        const updatedDaysOfWeek = value.slice(0);
        if (!value.includes(day.value)) {
            updatedDaysOfWeek.push(day.value);
            updatedDaysOfWeek.sort((a, b) => {
                return a - b;
            });
        } else {
            updatedDaysOfWeek.splice(value.indexOf(day.value), 1);
        }

        onChange(updatedDaysOfWeek);
    };

    return (
        <div className={classNamesAppended}>
            {label && (
                <InputLabel className="day-of-week-picker_label" shrink required>
                    {label}
                </InputLabel>
            )}
            <article>
                {(overrideOptions ?? weekDayOptions).map((day, idx) => {
                    const isSelected = value.includes(day.value);
                    const CheckboxIcon = isSelected ? CheckBoxChecked : CheckBoxUnchecked;

                    return (
                        <Button
                            dense
                            key={idx}
                            disabled={disabled}
                            data-testid={`day-picker-${day.label.toLowerCase()}`}
                            className={`week-day ${value.includes(day.value) ? 'selected' : ''}`}
                            color={value.includes(day.value) ? 'blue' : 'neutral'}
                            variant={value.includes(day.value) ? selectedBtnVariant : 'smooth'}
                            startIcon={<CheckboxIcon />}
                            onClick={() => onToggleDayOfWeek(day)}
                        >
                            {day.label}
                        </Button>
                    );
                })}
            </article>
        </div>
    );
};

export default DayOfWeekPicker;
